import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import PageHeader from 'src/components/NewRenterInterface/PageHeader/PageHeader';

interface Props {
  backRoute: string;
  title?: string;
}

/**
 * Skeleton for CertificationSnapshotDetailPage while the snapshot is loading.
 * Each shimmer row mirrors the SectionCard layout: a bold section name line and
 * a narrower answer-count line, with a chevron placeholder on the right.
 */
export function CertificationSnapshotDetailSkeleton({
  backRoute,
  title,
}: Props): React.ReactElement {
  const rows = [
    { nameWidth: '55%', countWidth: '25%' },
    { nameWidth: '70%', countWidth: '20%' },
    { nameWidth: '45%', countWidth: '30%' },
    { nameWidth: '60%', countWidth: '22%' },
    { nameWidth: '50%', countWidth: '28%' },
  ];

  return (
    <Box
      sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: '100px' }}
    >
      <PageHeader title={title ?? ''} backRoute={backRoute} />

      <Stack
        aria-busy="true"
        aria-label="Loading certification snapshot"
        spacing={1.5}
        sx={{ px: 2 }}
      >
        {rows.map((row, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'background.paper',
              borderRadius: '16px',
              boxShadow: '0 1px 8px rgba(0,0,0,0.03)',
              py: '14px',
              px: 2,
            }}
          >
            <Stack spacing={0.5} sx={{ flex: 1 }}>
              <Skeleton
                variant="text"
                width={row.nameWidth}
                height={18}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width={row.countWidth}
                height={14}
                animation="wave"
              />
            </Stack>
            <Skeleton
              variant="circular"
              width={18}
              height={18}
              animation="wave"
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
